export default __webpack_public_path__ + "static/media/Conscript's Gauntlets of the Golden Sun.4d82c442.jpg";